/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SelectEnvironmentBody = zod
	.object({
		environment_id: zod.uuid().describe('Environment ID to select')
	})
	.describe('Request body for selecting an environment');

export type SelectEnvironmentBody = zod.input<typeof SelectEnvironmentBody>;
export type SelectEnvironmentBodyOutput = zod.output<typeof SelectEnvironmentBody>;
